import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import SurveyService from '@/core/services/survey.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateSurveyComponent extends Vue {

  surveyService: any = new SurveyService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  name: string = "";
  description: string = "";
  instructions: string = "";


  mounted (){
    const _ = this;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  create(){
    const _ = this;
    let survey = {
      name: _.name,
      description: _.description,
      instructions: _.instructions
    };

    _.isLoading = true;
    _.surveyService.create(survey).then((data: any) => {
      console.log(data);
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push(`${data['data'].survey.id}/section/create`);
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  validations(name = '', description = '', instructions = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("Por favor escribe en nombre");
    }
    if(description == ''){
      _.genericErr.push("Por favor escribe una descripción");
    }
    if(instructions == ''){
      _.genericErr.push("Por favor escribe las Instrucciones");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
